import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { Paper, Tabs, Tab } from '@mui/material';
import TabPanel from '../../TabPanel'; // Adjust the import path as needed.

import TripDetailMessagesTable from './TripDetailMessagesTable'; // Ensure the path to MessagesTable.tsx is correct.
import TripDetailActivityTab from './TripDetailActivityTab';
// import TripLegMonitoringSection from './TripLegsListTable';
import TripDetailMapTab from './TripDetailMapTab';
import ActivityTile from './TripDetailInfoAction';

const TripActivitiesMapMessages: React.FC = () => {
  const PREFIX = 'TripActivitiesMapMessages';

  const classes = {
    container: `${PREFIX}-container`,
  };

  const StyledBox = styled(Paper)(({ theme }) => ({
    [`&.${classes.container}`]: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
    },
  }));

  const { t } = useTranslation('common');

  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (_event: React.ChangeEvent<{}>, newValue: number) => {
    setTabIndex(newValue);
  };
  return (
    <StyledBox elevation={0} className={classes.container}>
      {/* <TripLegMonitoringSection /> */}

      <ActivityTile
        // Example  - will be passed from F1REQ-2153 task
        lastUpdate="9:10AM (13 minutes ago)"
        scenario={{
          action: 'Verify driver location',
          solution: 'Check map to verify last known location.',
        }}
      />

      <Tabs
        indicatorColor="primary"
        textColor="primary"
        value={tabIndex}
        onChange={handleTabChange}
        variant="fullWidth">
        <Tab label={t('tripActivitiesMapMessages.activities')} />
        <Tab label={t('tripActivitiesMapMessages.map')} />
        <Tab label={t('tripActivitiesMapMessages.messages')} />
      </Tabs>
      <TabPanel value={tabIndex} index={0}>
        <TripDetailActivityTab />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        {/* <TripDetailMapTab /> */}
      </TabPanel>
      <TabPanel value={tabIndex} index={2}>
        <TripDetailMessagesTable />
      </TabPanel>
    </StyledBox>
  );
};

export default TripActivitiesMapMessages;
